import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { startSteps } from '../../data/content';
export function HowToStart() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" aria-labelledby="start-title" data-id="element-234" data-mp="3gqir5klqd9ah">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="3brz57k74zxi4">
        <SectionHeading id="start-title" data-id="element-236" data-mp="3bqwh1k17895w">
          How to start using <span className="text-accent-600" data-id="element-237" data-mp="36t4dfsr6yylv">your blueprint</span>
        </SectionHeading>

        <ol className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-238" data-mp="32r9darkzyr9o">
          {startSteps.map((s, i) => <li key={s.title} className="flex gap-4 rounded-2xl bg-mist p-5 lg:flex-col" data-id="element-239" data-mp="2xrenysgve9qq" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-lg font-black text-gold-400" data-id="element-240" data-mp="2st3dcfir3v7g">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div data-id="element-241" data-mp="r2i7xcdi456y">
                <h3 className="font-display text-lg font-black uppercase leading-tight text-navy-900" data-id="element-242" data-mp="r200djle24jq">{s.title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink/75" data-id="element-243" data-mp="1nzj5lbpz8up7">{s.body}</p>
              </div>
            </li>)}
        </ol>

        <SectionCTA label="Start step 01 now" data-id="element-244" data-mp="1e023f49xoyxz" />
      </div>
    </section>;
}